import { ApplicationConfig, CSP_NONCE, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    {
      provide: CSP_NONCE,
      useValue: 'OJus83Xg5KqfZlDAo1Rm4WxtiLUCyRHuU7ZhcN5B1So='
    }
  ]
};
